import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import S3FileUpload from "react-s3";
import Loading from "../../components/Common/Loading";

function Career(props) {
  const [isEmpty, setIsEmpty] = useState(false);
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const allFields = watch();
  // AWS config
  const config = {
    bucketName: process.env.REACT_APP_BUCKET_NAME,
    dirName: "career",
    region: "eu-central-1",
    accessKeyId: process.env.REACT_APP_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_ACCESS_SECRET,
  };

  const user = useSelector((state) => state.User);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // HandleImageUpload
  const handleLogoUpload = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        setImage(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };

  // get getCareerPage
  const getCareerPage = () => {
    setIsLoading(true);
    apiReq(url.GET_CAREER, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setValue("title", res.data.title);
          setValue("heading", res.data.heading);
          setValue("vision", res.data.vision);
          setValue("mission", res.data.mission);
          setValue("meta_title", res.data.meta_title);
          setValue("meta_description", res.data.meta_description);
          setImage(res.data.image);
          setIsEmpty(false);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setIsEmpty(true);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  const getDashboardDetails = () => {
    setIsLoading(true);
    apiReq(url.GET_DASHBOARD_DETAILS, {}, "get", {
      Authorization: `Bearer ${user.user?.token}`,
    });
  };
  useEffect(() => {
    getCareerPage();
    getDashboardDetails();
  }, []);

  // Todo: Create contactus page
  const createContactUs = (data) => {
    if (isEmpty) {
      setIsLoading(true);
      apiReq(
        url.CREATE_CAREER,
        {
          title: data.title,
          heading: data.heading,
          vision: data.vision,
          mission: data.mission,
          image: image,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_CAREER,
        {
          title: data.title,
          heading: data.heading,
          vision: data.vision,
          mission: data.mission,
          image: image,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {isLoading && <Loading />}
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Career Page</h5>
              <hr />
              <form onSubmit={handleSubmit(createContactUs)}>
                <div className="mt-4">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label>Image</label>
                        <div
                          className="dropzone p-4 mb-3"
                          style={{ minHeight: 120 }}
                        >
                          {!image ? (
                            <div
                              className="needsclick"
                              // {...getRootProps()}
                            >
                              {/* <input /> */}
                              <div className="mb-3">
                                <i className="ri-image-line display-4 text-muted"></i>
                              </div>
                              <h5 className="opacity-40">Featured Image</h5>
                              <input
                                type="file"
                                className="image_upload_input"
                                onChange={(e) => handleLogoUpload(e)}
                              />
                            </div>
                          ) : (
                            <div className="filled_image">
                              <img
                                src={image}
                                alt="image"
                                className="img-fluid"
                              />
                              <div
                                className="remove_image"
                                onClick={() => setImage(null)}
                              >
                                <i className="mdi mdi-close-thick"></i>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label>
                      Title{" "}
                      <small className="text-muted" style={{ opacity: 0.5 }}>
                        ({allFields?.title?.length} / 20)
                      </small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("title", { required: true })}
                      placeholder="Enter title"
                    />
                    {errors.title && (
                      <span className="text-danger">Title is required</span>
                    )}
                  </div>
                  <div className="mb-3">
                    <label>
                      Heading(H1){" "}
                      <small className="text-muted" style={{ opacity: 0.5 }}>
                        ({allFields?.heading?.length} / 30)
                      </small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("heading", { required: true })}
                      placeholder="Enter heading"
                    />
                    {errors.heading && (
                      <span className="text-danger">Heading is required</span>
                    )}
                  </div>
                  <div className="mb-3">
                    <label>
                      Vision{" "}
                      <small className="text-muted" style={{ opacity: 0.5 }}>
                        ({allFields?.vision?.length} / 200)
                      </small>
                    </label>
                    <textarea
                      type="text"
                      className="form-control"
                      {...register("vision", { required: true })}
                      placeholder="Enter vision text"
                    />
                    {errors.vision && (
                      <span className="text-danger">
                        Vision text is required
                      </span>
                    )}
                  </div>
                  <div className="mb-3">
                    <label>
                      Mission{" "}
                      <small className="text-muted" style={{ opacity: 0.5 }}>
                        ({allFields?.mission?.length} / 200)
                      </small>
                    </label>
                    <textarea
                      type="text"
                      className="form-control"
                      {...register("mission", { required: true })}
                      placeholder="Enter mission text"
                    />
                    {errors.mission && (
                      <span className="text-danger">
                        Mission text is required
                      </span>
                    )}
                  </div>
                </div>
                <h5 className="mt-4">SEO Meta Tags</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Meta Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_title?.length} / 70)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_title", { required: false })}
                    placeholder="Enter title"
                  />
                </div>
                <div className="mb-3">
                  <label>
                    Meta Description{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_description?.length} / 200)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_description", { required: false })}
                    placeholder="Enter description"
                  />
                </div>
                <hr />
                <div>
                  <button className="btn btn-primary" type="submit">
                    Save changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Career;
